import { Component, inject, input } from '@angular/core';
import { DocumentItemPartial, DocumentItemTypeEnum, FavoriteFieldEntity } from '@domain';
import { TranslatePipe } from '@ngx-translate/core';
import { TrashDocumentItemEntity } from 'src/app/domain/entities/trash-document-item.entity';
import { EditDataService } from '../../../services/_edit-data.service';
import { EditService } from '../../../services/edit-service';
import { CardBaseComponent } from '../_card-base/card-base.component';
import { CardTypes } from '../_card-base/enums/card-types.enum';
import { InlineTextEditorComponent } from '../_card-base/inline-text-editor/inline-text-editor.component';

/**
 * Card de texto (título, subtítulo, texto). O texto é editado DIRETO na folha pelo
 * `inline-text-editor`; o tipo, o tamanho e a cor ficam na barra do topo do editor
 * (edit-toolbar), então o rail deste card só tem IA, ⋯ e a lixeira.
 */
@Component({
    selector: 'text-card',
    templateUrl: 'text-card.component.html',
    styleUrl: 'text-card.component.scss',
    imports: [CardBaseComponent, InlineTextEditorComponent, TranslatePipe],
})
export class TextCardComponent {
    public field = input<DocumentItemPartial>();
    public favoriteField = input<FavoriteFieldEntity>();
    public trashField = input<TrashDocumentItemEntity>();
    public type = input<CardTypes>(CardTypes.DEFAULT);
    public selected = input<boolean>(false);

    public readonly textTypes = DocumentItemTypeEnum;

    // * [Injects]
    public editService = inject(EditService);
    public editDataService = inject(EditDataService);

    /**
     * Retorna o campo atual
     * @returns DocumentItemPartial | TrashDocumentItemEntity | FavoriteFieldEntity
     */
    public getCurrentField(): DocumentItemPartial {
        switch (this.type()) {
            case 'default':
                return this.field();
            case 'trash':
                return this.trashField().item;
            case 'favorite':
                return this.favoriteField().field;
        }
    }
}
